import { render, staticRenderFns } from "./ExpandabelTable.vue?vue&type=template&id=2ec40f6f"
import script from "./ExpandabelTable.vue?vue&type=script&lang=js"
export * from "./ExpandabelTable.vue?vue&type=script&lang=js"
import style0 from "./ExpandabelTable.vue?vue&type=style&index=0&id=2ec40f6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports